export const STATUS_OPTIONS = [
    { value: 'active', label: 'Aktiv', color: '#10b981' },
    { value: 'paused', label: 'Inaktiv', color: '#f59e0b' },
    { value: 'completed', label: 'Abgeschlossen', color: '#0284c7' },
    { value: 'archived', label: 'Archiv', color: '#9ca3af' },
    { value: 'deleted', label: 'Gelöscht', color: '#ff3b30' }
];
